export * from './src/cloud-resourceusage-v1-resource-usage-data.universal.js';
